import { render } from "./ComercioCredito.vue?vue&type=template&id=acd7f956"
import script from "./ComercioCredito.vue?vue&type=script&lang=js"
export * from "./ComercioCredito.vue?vue&type=script&lang=js"

import "./ComercioCredito.vue?vue&type=style&index=0&id=acd7f956&lang=scss"

import exportComponent from "/Volumes/Baguer/Develop/Quac/pagosquac-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__